import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { withCustomerAuth } from "../../../admin/components/GetAuth";
import { useWebsite } from "../../../context/WebsiteContext";
import { useSiteBranding } from "../../../hooks/useSiteBranding";
import CartView from "../../../frontend/pages/shop/components/CartView";
import styles from "../../../frontend/pages/shop/shop.module.css";
import CustomerShell from "./CustomerShell";

// Same cart body as the public /shop/cart, inside the customer panel frame
const CustomerCart = () => {
  const { websiteData } = useWebsite();
  useSiteBranding("Your cart", websiteData);

  return (<CustomerShell eyebrow="Shop Now" title="Your cart" actions={<Button component={Link} to="/customer/shop" className={styles.SecondaryBU}>Continue shopping</Button>}>
    <div className={styles.Embedded}>
      <CartView shopPath="/customer/shop" />
    </div>
  </CustomerShell>);
};

export default withCustomerAuth(CustomerCart);
